import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {infoColor} from "../../assets/jss/material-dashboard-pro-react";
import CheckboxAPI from "@material-ui/core/Checkbox";

const Checkbox = withStyles({root: {color: infoColor[0], '&$checked': {color: infoColor[0]}}})(props => (
  <CheckboxAPI color="default" {...props} />
));
export default Checkbox;
